$(document).ready(() => {
    /* navigation menu  */
    const $navigation = $('#navbarSupportedContent');
    /**
     * Mobile
     */
    
     $('body').on('click', '.menu-item-has-children > a', function (e) {
      $window = $(window);
  
      if ($window.width() < 1199) {
        $(this).parent('li').addClass('open');
        $('.navbar-collapse').addClass('overflow-hidden');
        e.preventDefault();
      }
    });
    
    $navigation.find('.btn-return').on('click', function() {
      $(this).closest('li').removeClass('open');
      $('.navbar-collapse').removeClass('overflow-hidden');
    });
    $('.navbar-toggler').on('click', function() {
        $("html, body").toggleClass('fixed-body');
    });
});